// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".object-video .video[data-v-2132d920]{width:100%}.object-video .video iframe[data-v-2132d920],.object-video .video video[data-v-2132d920]{width:100%;height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
